import React, { Component, createRef } from 'react';

// CSS
import '../Courses/Courses.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch, uploadCourseMedia } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

const CATEGORIES = [
    { label: 'ملفات مجانية للتحميل', value: 'DOWNLOAD' },
    { label: 'فيديوهات تعليمية', value: 'TUTORIAL' },
    { label: 'مقالات', value: 'ARTICLE' },
];
const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.label]));

const EMPTY_FORM = { id: null, title: '', description: '', linkUrl: '', category: 'DOWNLOAD' };

/** Manages the "Resources" page (free downloads / tutorials / articles) -- see
 *  ResourceController on the backend. Kept deliberately simple (4 fields, one optional file
 *  upload) since the whole point was to make this easy for a teacher to fill in themselves. */
class Resources extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        items: [],
        loading: true,
        form: EMPTY_FORM,
        saving: false,
        uploading: false,
        uploadProgress: 0,
    }

    componentDidMount() {
        document.title = properties.site_name + " | الموارد";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        this.load();
    }

    load = () => {
        apiFetch("/resources/mine")
            .then(items => this.setState({ items, loading: false }))
            .catch(error => {
                console.error('Error:', error);
                this.setState({ loading: false });
            });
    }

    resetForm = () => this.setState({ form: EMPTY_FORM });

    editItem = (item) => {
        this.setState({ form: { id: item.id, title: item.title || '', description: item.description || '', linkUrl: item.linkUrl || '', category: item.category } });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    deleteItem = (item) => {
        if (!window.confirm(`هل أنت متأكد من حذف "${item.title}"؟`)) return;
        apiFetch(`/resources/${item.id}`, { method: "DELETE" })
            .then(() => this.load())
            .catch(error => {
                console.error('Error:', error);
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    uploadFile = async (event) => {
        const file = event.files && event.files[0];
        if (!file) return;
        this.setState({ uploading: true, uploadProgress: 0 });
        try {
            const url = await uploadCourseMedia(file, (pct) => this.setState({ uploadProgress: pct }));
            this.setState(s => ({ form: { ...s.form, linkUrl: url }, uploading: false }));
            this.toast.current.show({ severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الملف' });
        } catch (error) {
            console.error('Error:', error);
            this.setState({ uploading: false });
            this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'فشل رفع الملف' });
        } finally {
            event.options && event.options.clear && event.options.clear();
        }
    }

    save = () => {
        const { form, items } = this.state;
        if (!form.title || !form.linkUrl) {
            this.toast.current.show({ severity: 'error', summary: 'تنبيه', detail: 'من فضلك أدخل العنوان والرابط أو ارفع ملف' });
            return;
        }
        this.setState({ saving: true });
        const body = {
            title: form.title,
            description: form.description,
            linkUrl: form.linkUrl,
            category: form.category,
            sortOrder: form.id ? undefined : items.length,
        };
        const request = form.id
            ? apiFetch(`/resources/${form.id}`, { method: "PUT", body })
            : apiFetch("/resources", { method: "POST", body });
        request
            .then(() => {
                this.setState({ saving: false, form: EMPTY_FORM });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم الحفظ' });
                this.load();
            })
            .catch(error => {
                console.error('Error:', error);
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { items, loading, form, saving, uploading, uploadProgress } = this.state;

        return (
            <div className="add-lesson-page">
                <Header pageName="الموارد" />
                <Toast ref={this.toast}></Toast>

                <div className="content">
                    <div className="container">
                        <Card title={form.id ? "تعديل عنصر" : "إضافة عنصر جديد"}>
                            <p style={{ color: '#888', fontSize: 13 }}>
                                البيانات دي هتظهر في صفحة "الموارد" على موقعك الخارجي، مقسّمة لثلاث أقسام حسب التصنيف اللي تختاره.
                            </p>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label">
                                            <Dropdown value={form.category} options={CATEGORIES} onChange={(e) => this.setState({ form: { ...form, category: e.value } })} />
                                            <label>التصنيف</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label">
                                            <InputText value={form.title} onChange={(e) => this.setState({ form: { ...form, title: e.target.value } })} />
                                            <label>العنوان</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label">
                                            <InputTextarea rows={2} value={form.description} onChange={(e) => this.setState({ form: { ...form, description: e.target.value } })} />
                                            <label>وصف مختصر</label>
                                        </span>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-8">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label">
                                            <InputText value={form.linkUrl} onChange={(e) => this.setState({ form: { ...form, linkUrl: e.target.value } })} placeholder="https://..." />
                                            <label>الرابط (لينك خارجي أو ملف مرفوع)</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <FileUpload
                                        name="resourceFile"
                                        customUpload
                                        uploadHandler={this.uploadFile}
                                        auto
                                        disabled={uploading}
                                        multiple={false}
                                        maxFileSize={200000000}
                                        chooseLabel={uploading ? "جاري الرفع..." : "أو ارفع ملف"}
                                        uploadLabel="رفع"
                                        cancelLabel="إلغاء"
                                        mode="basic"
                                    />
                                </div>
                                {uploading && (
                                    <div className="p-col-12" style={{ marginTop: -10 }}>
                                        <div className="upload-progress-row">
                                            <ProgressBar value={uploadProgress} style={{ flex: 1, height: '10px' }} />
                                            <span>{uploadProgress}%</span>
                                        </div>
                                    </div>
                                )}

                                <div className="p-col-12 p-md-12" style={{ display: 'flex', gap: 10 }}>
                                    <Button className={`add-button ${saving ? "loading" : ""}`} label={saving ? "جاري الحفظ..." : (form.id ? "حفظ التعديلات" : "إضافة")} onClick={this.save} />
                                    {form.id && <Button label="إلغاء" className="p-button-text" onClick={this.resetForm} />}
                                </div>
                            </div>
                        </Card>

                        <Card title="كل العناصر" style={{ marginTop: 20 }}>
                            {loading ? <p>جاري التحميل...</p> : items.length === 0 ? (
                                <p>لسه مفيش عناصر مضافة.</p>
                            ) : (
                                items.map((item) => (
                                    <div className="course-item-row" key={item.id}>
                                        <div className="course-item-info">
                                            <span className="p-tag">{CATEGORY_LABEL[item.category] || item.category}</span>
                                            <span>{item.title}</span>
                                        </div>
                                        <div>
                                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => this.editItem(item)} />
                                            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" onClick={() => this.deleteItem(item)} />
                                        </div>
                                    </div>
                                ))
                            )}
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

export default Resources;
